// Dropdown choice lists per module — composed from family files.
// Split from constants.js — edit the family files (choices-*.js), not this composer.

import { queueChoices } from '../Choices/queue'
import { contentChoices } from '../Choices/content'
import { templateChoices } from '../Choices/template'
import { merchantChoices } from '../Choices/merchant'
import { restaurantChoices } from '../Choices/restaurant'
import { productChoices } from '../Choices/product'
import { miscChoices } from '../Choices/misc'

export const choices = {
    CHOICES: {
        ...queueChoices,
        ...contentChoices,
        ...templateChoices,
        ...merchantChoices,
        ...restaurantChoices,
        ...productChoices,
        ...miscChoices,
    },
}
